<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  },
  head: {
    meta: function () {
      return [
        { property: 'og:url', content: location.origin + this.$route.path },
        { property: 'og:site_name', content: '雛菊書房' },
        { property: 'twitter:site', content: '@HinagikuBooks' }
      ]
    }
  },
};
</script>
